<!-- 登录注册功能已经通过用户中心全部实现，本文件失效 -->
<template>
  <div class="mainBackground">
    <header-bar :type="type"></header-bar>
    <div class="img-cont">
      <img class="bg-img" id="red" src="~@/assets/login/red.svg" />
      <img class="bg-img" id="green" src="~@/assets/login/green.svg" />
      <img class="bg-img" id="blue" src="~@/assets/login/blue.svg" />
    </div>
    <div class="login-cont">
      <regist v-if="successShow"></regist>
      <router-view></router-view>
      <p class="footer">
        ©2021 hs.net 版权所有 ICP备案号：浙ICP备09092082号-30 ICP
        经营许可证：浙B2-20170536
      </p>
    </div>
  </div>
</template>

<script>
import HeaderBar from "@/views/frontViews/components/headerBar";
import Regist from "@/views/frontViews/components/regist";
export default {
  name: "register",
  data() {
    return {
      type: "register",
      formData: {},
      formRules: {},
      isSave: false,
      flag: true,
      successShow: this.$route.name == "注册成功" ? false : true
    };
  },
  components: {
    HeaderBar,
    Regist
  },

  methods: {
    change() {
      console.log("状态发生改变了");
    },
    start(dom, startX, startY, speed, towards) {
      var main = document.getElementById(dom);
      var sy = startY;
      var speedy = 1;
      var sx = startX;
      var speedx = 1;

      var imgh = 200;
      var imgw = 200;

      var winh = document.documentElement.clientHeight;
      var winw = document.documentElement.clientWidth;
      setInterval(function() {
        if (towards) {
          sy += speedy;
          sx += speedx;
        } else {
          sy -= speedy;
          sx -= speedx;
        }

        //y轴运动
        if (sy <= 0) {
          speedy = -speedy;
        }
        if (sy >= winh - imgh) {
          speedy = -speedy;
          sy = winh - imgh;
        }
        //x轴运动
        if (sx <= 0) {
          speedx = -speedx;
        }
        if (sx >= winw - imgw) {
          speedx = -speedx;
          sx = winw - imgw;
        }
        main.style.top = sy + "px";
        main.style.left = sx + "px";
      }, speed);
    }
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.start("red", 250, 700, 12);
    this.start("green", 80, 350, 13, "right");
    this.start("blue", 1300, 120, 14, "right");
  }
};
</script>
<style lang="scss" scoped>
.mainBackground {
  background: #f3f7fe;
  height: 100%;
  position: relative;
  .img-cont {
    min-height: 100vh;
    position: relative;
    overflow: hidden;
    z-index: 0;
    background: transparent;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    .bg-img {
      position: absolute;
      width: 400px;
      height: 400px;
    }
  }
  .login-cont {
    width: 1200px;
    height: 579px;
    /*background: url(/open/images/register/registBg.png) center center no-repeat;*/
    /*background-size: 100% 100%;*/
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: absolute;
    // padding-top: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .footer {
      margin-top: 40px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #999999;
      text-align: center;
      line-height: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/Register.vue